import * as React from "react";
const SvgFiRrGoalNet = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M19 3H5C2.243 3 0 5.243 0 8v12a1 1 0 0 0 1 1h.5a1 1 0 0 0 .708-.293l2.791-2.794 2.794 2.794a.997.997 0 0 0 1.414 0L12 17.914l2.793 2.793a.997.997 0 0 0 1.414 0L19 17.914l2.793 2.793A1 1 0 0 0 22.5 21h.5a1 1 0 0 0 1-1V8c0-2.757-2.243-5-5-5M2 8c0-.027.007-.052.008-.078l1.646 1.646L2 11.222zm3.068 2.982 2.014 2.014-2.085 2.087-2.015-2.015zm1.414-1.414L8.569 7.48l2.011 2.012-2.086 2.088-2.013-2.013zM10.995 5H13c.034.049 1.01 1.06 1.01 1.06l-2.015 2.018-2.01-2.011s.975-1.011 1.011-1.066zm1 5.907 2.092 2.092L12 15.086l-2.091-2.091zm1.413-1.415 2.015-2.018 2.094 2.094-2.017 2.017zm5.523 1.491 2.086 2.086L19 15.086 16.914 13zm1.414-1.414 1.646-1.646c0 .027.008.051.008.078v3.223zm-2.451-4.568h1.105c.849 0 1.613.358 2.159.927l-2.227 2.227-2.095-2.095zm-12.895 0h1.09l1.066 1.066-2.088 2.088L2.84 5.928a2.98 2.98 0 0 1 2.159-.927m-3 13.084v-3.17l1.584 1.584zm6.5.502-2.088-2.088 2.085-2.087 2.09 2.09L8.5 18.588zm7 0-2.086-2.086 2.087-2.087 2.086 2.086-2.086 2.086zm4.914-2.086 1.586-1.586v3.172z"
    />
  </svg>
);
export default SvgFiRrGoalNet;
